import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AppLayout from '../layouts/AppLayout.vue'
import AuthLayout from '../layouts/AuthLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'services',
        path: 'services',
        component: () => import('../pages/services/ServicesPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'orders',
        path: 'orders',
        component: () => import('../pages/orders/OrdersPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'invoices',
        path: 'invoices',
        component: () => import('../pages/invoices/Invoices.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'tickets',
        path: 'tickets',
        component: () => import('../pages/tickets/Tickets.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'payments',
        path: 'payments',
        component: () => import('../pages/payments/PaymentsPage.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'verify-email',
        path: 'verify-email',
        component: () => import('../pages/auth/VerifyEmail.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'verify-otp',
        path: 'verify-otp',
        component: () => import('../pages/auth/VerifyOtp.vue'),
        meta: { guestOnly: true },
      },
      {
        name: 'reset-password',
        path: 'reset-password',
        component: () => import('../pages/auth/PasswordReset.vue'),
        meta: { guestOnly: true },
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('access_token')

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' })
  } else if (to.meta.guestOnly && isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
